import { zExt } from "@redotech/redo-model/common/zod-util";
import { DraftReturnSchema } from "@redotech/redo-model/draft-return/draft-return";
import { z } from "zod/v4";

export const addMerchantOverrides = {
  name: "addMerchantOverrides" as const,
  input: z.object({
    draftReturnId: zExt.objectId(),
    adjustmentOverrides: z.array(
      z.object({ pendingReturnItemId: z.string(), adjustment: z.number() }),
    ),
    greenReturnOverrides: z.array(
      z.object({ pendingReturnItemId: z.string(), greenReturn: z.boolean() }),
    ),
    customerPaysReturnShipping: z.boolean(),
    customerPaysNewOrderShipping: z.boolean(),
    flagReturn: z.boolean(),
    manualReview: z.boolean(),
    discountCodes: z.array(z.string()),
    applyAutomaticDiscounts: z.boolean(),
  }),
  output: z.object({ draftReturn: DraftReturnSchema }),
};
